import {
  FETCH_ICX__PRICING_REQUEST,
  FETCH_ICX_PRICING_RESPONSE,
  FETCH_ICX_PRICING_ERROR,
} from "../actions/icxPricing.js";

const defaultState = {
  isLoading: false,
  fetchError: "",
  price: 0,
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_ICX__PRICING_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchError: "",
      };

    case FETCH_ICX_PRICING_RESPONSE:
      return {
        ...state,
        price: action.data,
        isLoading: false,
        fetchError: "",
      };

    case FETCH_ICX_PRICING_ERROR:
      return {
        ...state,
        fetchError: action.error,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default reducer;
